export default __webpack_public_path__ + "static/media/purple_pawn.718cf337.png";